import * as React from 'react';
import * as _ from 'lodash';
import { observer } from 'mobx-react';
import { useOrgStore } from '../hooks/useOrgStore';
import { SerializedAppResource } from '@journeyapps-platform/types-accounts-hub';
import { styled } from '../theme';
import { SelectWidget } from '../widgets/select/SelectWidget';
import { throttle } from '../utils/async-throttle';
import { useState } from 'react';
import * as accounts from '@journeyapps-platform/types-accounts-hub';
import { AppModel } from '@journeyapps-platform/lib-journey-core';
import { useSystem } from '../hooks/useSystem';

export interface SmartProjectSelectWidgetProps {
  className?: any;
  project?: SerializedAppResource;
  onChange: (app: SerializedAppResource) => any;
}

export const SmartProjectSelectWidget: React.FC<SmartProjectSelectWidgetProps> = observer((props) => {
  const orgStore = useOrgStore();
  const system = useSystem();
  const [searching, setSearching] = useState<boolean>(false);

  const mapAppsToResources = (apps: AppModel[]) => {
    return apps.map((app) => app.model);
  };

  const [searchResults, setSearchResults] = useState<accounts.SerializedAppResource[]>(
    mapAppsToResources(orgStore.current_org?.apps.items || [])
  );

  const mapAppsToOptions = () => {
    return _.chain(searchResults || [])
      .filter((app) => !!app.source)
      .sortBy((app) => {
        return app.name?.toLowerCase();
      })
      .map((app) => {
        return { label: app.name, value: app.id };
      })
      .value();
  };

  const doSearch = throttle(
    async (search_string: string) => {
      if (!search_string) {
        setSearchResults(mapAppsToResources(orgStore.current_org?.apps.items || []));
        return 1;
      }
      try {
        setSearching(true);
        const res = await system.accountV5Client.searchApps({
          search: search_string,
          limit: 20
        });
        setSearchResults(res.objects);
      } finally {
        setSearching(false);
      }
      return 1;
    },
    { wait_ms: 500 }
  );

  React.useEffect(() => {
    orgStore.current_org?.loadApps().then((apps) => {
      setSearchResults(mapAppsToResources(orgStore.current_org?.apps.items || []));
    });
  }, [orgStore.current_org]);

  return (
    <div key={orgStore.current_org?.model?.label} className={props.className}>
      <S.StyledSelect
        placeholder={'Select project'}
        isLoading={!orgStore.current_org || orgStore.current_org?.apps.loading || searching}
        onChange={(value: any) => {
          const project = orgStore.current_org?.apps.items.find((a) => a.id === value.value)!;
          props.onChange(project.model);
        }}
        onInputChange={(value) => {
          doSearch(value);
        }}
        value={props.project ? { label: props.project.name, value: props.project.id } : null}
        options={mapAppsToOptions()}
      />
    </div>
  );
});

namespace S {
  export const StyledSelect = styled(SelectWidget)``;
}
